import { includes } from "lodash"

export const ROW_HEADER_HEIGHT = 38
export const COL_SELECTION_WIDTH = 16 * 2

export const isRowSelected = (rowKey, record, { selectedRowKeys, selected } = {}) => {
    if (typeof selected === "function") {
        return selected(rowKey, record)
    }
    if (selectedRowKeys) {
        return includes(selectedRowKeys, rowKey)
    }
    return false
}
